import React from "react";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import { Trophy } from "lucide-react";

const LeaderBoardBlock = ({ item, community_id, season_id, challenge_id, activity_id }) => {
  return (
    <Card className="mb-2">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 flex-1">
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10">
              {item.rank <= 3 ? (
                <Trophy className={`h-5 w-5 ${item.rank === 1 ? "text-yellow-500" :
                    item.rank === 2 ? "text-gray-400" :
                      "text-orange-600"
                  }`} />
              ) : (
                <span className="font-bold text-gray-600">#{item.rank}</span>
              )}
            </div>
            <div className="flex-1">
              <div className="font-semibold">{item.first_name} {item.last_name}</div>
              <div className="text-sm text-gray-500">{item.email}</div>
            </div>
          </div>
          <div className="text-right">
            <Badge variant="secondary" className="text-lg font-bold">
              {item.score || item.num_days_completed || item.percent_complete || 0}
            </Badge>
            <div className="text-xs text-gray-500 mt-1">
              {item.num_days_completed !== undefined ? "days" : "points"}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default LeaderBoardBlock;
